import React from 'react';
import Helmet from "react-helmet";
import {Card, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import speaker6 from '../../assets/images/contents/speaker6.jpg';

export const AssistantProfessorDrUbydulHaque = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">AssistantProfessorDrUbydulHaque</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker6} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b> Assistant Professor Dr. Ubydul Haque</b>
    </p>

    <p style={{textAlign:'center'}}>
      University of North Texas Health Science Center
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Spatio-temporal Dynamics of Dengue, Chikungunya, and Zika 
      Viruses in Mexico: A Potential Co-circulation Problem</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      Spatio-temporal patterns of Aedes-borne viruses (Chikungunya, Dengue, and Zika) throughout history have been dynamic because of changes in the 
      human host, viral genetics, mosquito vector, and the environment. Nearly 105 million dengue infections are reported globally per year. The spread 
      of Chikungunya and Zika into the Americas increased transmission and diagnosis complexity due to co-circulation in mosquitoes and humans. We present 
      an integrated analysis of Aedes-borne diseases, local climate, and socio-demographic profiles of 2,511 municipalities in Mexico. We used SaTScan to 
      detect spatial clusters and utilized the Pearson correlation coefficient, Randomized Dependence Coefficient and SHapley Additive exPlanations to 
      analyze the influence of socio-demographic and climatic factors on incidence. We compared six models including XGBoost, decision tree, SVM with RBF 
      kernel, K nearest neighbors, random forest and neural network to predict spatial clusters. Socio-demographic and climatic factors had significant and 
      differential influence on Aedes-borne virus transmission in different regions of Mexico.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      <i>Education & Experience:</i><br/>
        I have received a Ph.D. in Public Health from the Nagasaki University, Japan, Master of Science in Geoinformatics from the Royal Institute of Technology, 
        Sweden, and a Bachelor of Science from Khulna University, Bangladesh. I was also a guest Ph.D. student in Norway for one year and completed a post-doctoral 
        research fellowship from the Johns Hopkins University. Prior to joining the UNTHSC School of Public Health in 2018, I held a previous faculty position with 
        the Baldwin Wallace University, as Assistant Professor.
    </p>

    <p style={{ textAlign:'justify'}}>
      <i>Teaching Areas & Public Health Interests:</i><br/>
        I have been involved with global health and community-based research for more than 10 years, in the areas of spatial epidemiology. I have taught a variety 
        of undergraduate and graduate courses, such as Biostatistics, GIS Health Analysis and Introduction to Public Health. I have had the opportunity to supervise 
        and mentor undergraduate and graduate students.
    </p>

    <p style={{ textAlign:'justify'}}>
      <i>Professional Activities & Awards:</i><br/>
        I am an active member of the Association of American Geographers (AAG), the American Geophysical Union (AGU) and American Association for the Advancement 
        of Science (AAAS). I serve as an editorial board member of 12 peer-review journals. I also received several awards from different institutes across the globe.
    </p>

    <p style={{ textAlign:'justify'}}>
      <i>Scholarly Interests:</i><br/>
        I started my career studying spatial malaria epidemiology in Bangladesh and gradually expanded my research into other settings. The global fund and other
        international donors have invested multi-billion dollars in support of these control programs. I wanted to learn the impact of these programs. My studies 
        identified the location-specific successes and challenges which were welcomed by international donors, policymakers and public health professionals in those 
        countries. I have investigated factors associated with the risk of mortality and determinants of patient survival due to the Ebola virus outbreak in West 
        Africa and identified the spatiotemporal distribution and topographic risk factors for Zika virus in Colombia and Mexico for targeted interventions. More 
        recently I contributed to analyzing five years of individually reported national databases on arbovirus infections in Mexico. Here we used machine learning 
        techniques to analyze nearly quarter million laboratory confirmed cases on Chikungunya, Dengue, and Zika infections and identified the location-specific risk 
        factors including climatic parameters. Looking to the future and to aid in preparedness, I investigated the role of climate change in the spread of deadly 
        landslides in 130 countries over the last 20 years. Now I am studying the effects of climate change, community vulnerability and exposure to dengue in Laos 
        and Thailand, a four years project sponsored by the Research Council of Norway.
    </p>

    <p style={{ textAlign:'justify'}}>
      As a spatial epidemiologist, using geospatial and informatics tools, I investigate the underlying factors that affect human health, particularly in 
      less wealthy areas which are quite vulnerable to the impacts of environmental variability and change infectious disease epidemiology as it relates to 
      time, space and climate change. In addition, I examine the relationship between climate change and deadly landslides and its impact on public health 
      globally. I also have a keen interest to contribute to the ongoing and unforeseen challenges in global health.
    </p>

    <p style={{ textAlign:'justify'}}>
      I have investigated factors associated with the risk of mortality and determinants of patient survival due to the Ebola virus outbreak in West Africa 
      and identified the spatiotemporal distribution and topographic risk factors for Zika virus in Colombia and Mexico for targeted interventions.
    </p>

    <p style={{ textAlign:'justify'}}>
      I am also contributing to mapping, determining risk factors of COVID-19 transmission.
    </p>

    <p>Click this <a href = "https://www.unthsc.edu/school-of-public-health/dr-ubydul-haque/" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p>

  </div>
)